import api from '../../plugins/api';

// Закрывает приём: ссылка сделки перестаёт работать, присланные файлы остаются.
const revokeClientUploadLink = ({ dealId }) => {
  return api.post('/api/crm/clientUpload/revoke', { dealId });
};

export default revokeClientUploadLink;
